module.exports = __webpack_public_path__ + "static/media/menu.18b91ac4.svg";